import React from 'react';
import './Guidelines.scss';

const NewConversationGuidelines = () => {
    return (
        <div className='guidelines' id='ConversationGuidelines'>
        <p><span>When creating a log... Did you apply A3I methods?</span></p>
        <p><span>Analyze:</span> Understanding KPI’s and associate data to prioritize coaching needs</p>
        <p>Have you <span>A</span>nalyzed the data prior to speaking to them?</p>
        <p>Understanding KPI’s and ….</p>
        <p>Identify if the person has the skill or will to want to correct the behaviors. This should help you tailor the goals and your discussion.</p>
        <p><span >How does your team compare to others?</span></p>
        <p>Did you identify meeting with this person based on your team’s performance from last month? This shouldn’t be a discussion that is meant to be negative. It should be concise. Thank them for improving, 
            or achieving certain goals and then discuss in detail their area of opportunity. Every member on your team plays a key role in the overall team’s accomplishment.</p>
        <p><span>Align:</span> Using open-ended questions and self-discovery techniques to help associates recognize areas for improvement.</p>
        <p>Are you both <span >A</span>ligning on the next steps and the Improvement plan?</p>
        <p>What are they saying they need help in?</p>
        <p>Are you giving them attainable goals that you both agree on; making sure that you are challenging them?</p>
        <p>What are the SMART goals you agreed upon? This should be a collaboration between you and your employee.</p>
        <p id='goalLeftMargin'><span >SMART</span> goals are:
            <span >S</span>pecific,
            <span >M</span>easurable,
            <span >A</span>chievable,
            <span >R</span>elevant, and
            <span >T</span>ime-bound</p>
        <p><span>Articulate:</span> Improving coaching through role-playing and call flow strategies.</p>
        <p>Are you clearly <span >A</span>rticulating your expectations?</p>
        <p>Is there something they recognize they need to do?</p>
        <p>Don’t talk in circles, be very specific on what you’d like to see them improve upon and check for understanding.
            No one is perfect everyone has something they can do a little better. If they are a mid-performer, discuss where they were but utilize specific examples that may have prevented them from reaching their goals.</p>
        <p><span>Inspect:</span> Establishing optimal timeframes and methods for ensuring associates are applying new skills.</p>
        <p>Lastly, you should spot check, check in randomly to <span >I</span>nspect they are demonstrating the areas you discussed.</p>
        <p>Don’t forget to discuss dates on when you expect to see them improve or the next discussion.</p>
    </div>
    );
}

export default NewConversationGuidelines;
